import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "min-w-0 w-full" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "relative min-w-0" }
const _hoisted_4 = ["id", "disabled", "value", "placeholder"]


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminFormSearchInput',
  props: {
    modelValue: {},
    placeholder: { default: "Buscar…" },
    label: {},
    inputId: { default: "admin-search-input" },
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const onInput = (e: Event) => {
  emit("update:modelValue", (e.target as HTMLInputElement).value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: __props.inputId,
          class: "block text-xs sm:text-sm font-semibold text-slate-700 mb-1.5"
        }, _toDisplayString(__props.label), 9, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("input", {
        id: __props.inputId,
        type: "search",
        autocomplete: "off",
        disabled: __props.disabled,
        value: __props.modelValue,
        placeholder: __props.placeholder,
        class: "w-full min-w-0 pl-10 pr-3 py-2.5 sm:py-3 text-sm border border-slate-300 rounded-lg sm:rounded-xl bg-white shadow-sm focus:ring-2 focus:ring-red-500/30 focus:border-red-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
        onInput: onInput
      }, null, 40, _hoisted_4),
      _cache[0] || (_cache[0] = _createElementVNode("svg", {
        class: "pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 sm:w-5 sm:h-5 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24",
        "aria-hidden": "true"
      }, [
        _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
        })
      ], -1))
    ])
  ]))
}
}

})